import { Util } from "../util.js";
import { Article } from "./article.js";
import { SimilarCombosModal } from "./similar_combos_modal.js";

const util = new Util();

export class SingleComboModal {
	constructor(dom) {
		this._articles = [];
		this._id = util.readFromDataAttribute(dom, "combo_id");
		this._source = util.readFromDataAttribute(dom, "combo_src");
		this._articleCount = util.readFromDataAttribute(dom, "article_count");
		this._maxVisibleArticles = util.readFromDataAttribute(dom, "max_visible_articles");
		this._articleNumberFromADS = util.readFromDataAttribute(dom, "article_number_from_ads");
		this._comboType = util.readFromDataAttribute(dom, "combo_type");
		this._dom = dom;
		this._initializeArticles();
		this._initializeSimilarCombos();
		this._initializeShowAllButton();
		this._initializeMoodImage();
	}

	_initializeArticles() {
		this.articleDoms = Array.prototype.slice.call(this._dom.getElementsByClassName("combo-modal-article"), 0);
		this.articleDoms.forEach((articleDom, index) => {
			this._initializeArticle(articleDom, index);
		});
	}

	_initializeArticle(articleDom, index) {
		this._articles.push(new Article(articleDom));
		articleDom.addEventListener("click", () => this.sendClickArticleTrackingEvent(index));
	}

	_initializeSimilarCombos() {
		const containerDom = this._dom.querySelector("#similar_combos");
		this._similarCombos = containerDom ? new SimilarCombosModal(containerDom, this._comboType) : null;
	}

	sendViewTracking() {
		window.o_modal.modalTracking.sendLoadTrackingEvent(
			this,
			this._articles,
			Number.parseInt(this._articleCount) > Number.parseInt(this._maxVisibleArticles),
			this._similarCombos
		);
	}

	sendClickArticleTrackingEvent(index) {
		window.o_modal.modalTracking.sendClickArticleTrackingEvent(this, this._articles, index);
	}

	_sendMoreArticlesButtonClickEvent(newLoadedArticles) {
		window.o_modal.modalTracking.sendMoreArticlesButtonClickEvent(this, newLoadedArticles);
	}

	_initializeShowAllButton() {
		const button = this._dom.querySelector(".combo-modal__show-all-button");
		if (!button) return;
		button.addEventListener("click", () => {
			const template = this._dom.querySelector("#combo-modal__extra-articles");
			const grid = this._dom.querySelector(".combo-modal__main__articles-grid");
			grid.appendChild(template.content.cloneNode(true));
			button.closest(".combo-modal__button-wrapper").remove();

			const allArticleDoms = Array.prototype.slice.call(grid.getElementsByClassName("combo-modal-article"), 0);
			const newArticleDoms = allArticleDoms.slice(this.articleDoms.length);

			const firstNewArticleIndex = this._articles.length;

			newArticleDoms.forEach(articleDom => {
				this._initializeArticle(articleDom, firstNewArticleIndex);
			});

			this.articleDoms = allArticleDoms;
			this._sendMoreArticlesButtonClickEvent(this._articles.slice(firstNewArticleIndex));
		});
	}

	_initializeMoodImage() {
		this._transitionMoodImageToFullQualityWhenIsLoaded();
	}

	_transitionMoodImageToFullQualityWhenIsLoaded() {
		const wrapper = this._dom.querySelector(".combo-modal__main__mood-image");
		if (!wrapper) return;
		const img = wrapper.querySelector("picture img");
		if (!img) return;

		const markLoaded = () => wrapper.classList.add("mood-image--loaded");

		if (img.complete) {
			markLoaded();
		} else {
			img.addEventListener("load", markLoaded, { once: true });
			img.addEventListener("error", markLoaded, { once: true });
		}
	}

	getId() {
		return this._id;
	}

	getSource() {
		return this._source;
	}

	getArticleCount() {
		return this._articleCount;
	}

	getArticleNumberFromADS() {
		return this._articleNumberFromADS;
	}

	getComboType() {
		return this._comboType;
	}
}
